import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
          联系我们
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          {contactInfo.title}
        </h2>
        <p className="text-sm text-foreground-500 mb-2">{contactInfo.subtitle}</p>
        <p className="text-sm text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          {contactInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl border border-background-200/70">
            <i className="ri-mail-line text-xl text-primary-500"></i>
            <span className="text-sm text-foreground-700">{contactInfo.email}</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl border border-background-200/70">
            <i className="ri-wechat-line text-xl text-primary-500"></i>
            <span className="text-sm text-foreground-700">微信：{contactInfo.wechat}</span>
          </div>
        </div>
      </div>
    </section>
  );
}